import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validatePharmacy = (data, setError) => {
  var isValid = true;

  if (!data.inventory_id) {
    handleValidationChange("inventory_id", true, setError);
    isValid = false;
  } else {
    handleValidationChange("inventory_id", false, setError);
  }
  if (data.patient_name === "") {
    handleValidationChange("patient_name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("patient_name", false, setError);
  }
  if (data.unit_price === "") {
    handleValidationChange("unit_price", true, setError);
    isValid = false;
  } else {
    handleValidationChange("unit_price", false, setError);
  }
  if (
    data.quantity === "" ||
    parseFloat(data.quantity) > parseFloat(data.stock)
  ) {
    handleValidationChange("quantity", true, setError);
    isValid = false;
  } else {
    handleValidationChange("quantity", false, setError);
  }

  return isValid;
};

export const validateInventory = (data, setError) => {
  var isValid = true;

  if (data.item === "") {
    handleValidationChange("item", true, setError);
    isValid = false;
  } else {
    handleValidationChange("item", false, setError);
  }
  if (data.unit === "") {
    handleValidationChange("unit", true, setError);
    isValid = false;
  } else {
    handleValidationChange("unit", false, setError);
  }
  if (data.unit_price === "") {
    handleValidationChange("unit_price", true, setError);
    isValid = false;
  } else {
    handleValidationChange("unit_price", false, setError);
  }
  if (data.stock === "") {
    handleValidationChange("stock", true, setError);
    isValid = false;
  } else {
    handleValidationChange("stock", false, setError);
  }

  return isValid;
};
